import CustomerLoader from "../../../../../components/CustomLoader";
import {
  doTransformData,
  fallIncidentPlaceCols2,
  handlePointClicked,
  transformDataForBarChart,
} from "../formUtils";
import { LayerContent } from "../style";
import { useAnalyticsWrapper } from "../../../../../store/store";
import useAnalytics from "../../../../../hooks/useAnalytics";
import moment from "moment";
import { Fragment, useEffect, useState } from "react";
import SectionModal, { DefaultContainer } from "./SectionModal";
import {
  handleCSVDownload,
  handlePDFDownload,
} from "../../../../../utils/helpers/pdfCsvUtils";
import { incidentLists } from "../../dummyData/colums";
import { Grid, GridColumn, GridColumnProps } from "@progress/kendo-react-grid";
import {
  CenteredWholeNumCell,
  HeaderCenteredCell,
} from "../../../../../components/DynamicGrid/customCells";
import { TotalRow } from "../../../../../components/DynamicGrid/customRows";

const RepeatFall = ({
  setClickedIncident,
  isFetchingSelectedIncident,
  shareTableData,
}: any) => {
  const [tableData, setTableData] = useState<any>([]);
  const [grid, setGrid] = useState<any>([]);
  const [barData, setBarData] = useState<any>([]);
  const [residentName, setResidentName] = useState("");
  const [residentId, setResidentId] = useState("");
  const [showRepeatModal, setShowRepeatModal] = useState(false);
  const [repeatFallDetails, setRepeatFallDetails] = useState<any>([]);

  const { startDate, endDate, fallFacility } = useAnalyticsWrapper((state) => ({
    startDate: state.startDate,
    endDate: state.endDate,
    fallFacility: state.fallFacility,
  }));

  const { getOverviewRepeatfallIncidents, getRepeatFallDetails } = useAnalytics(
    {
      facility: fallFacility?.value || "",
      startDate: moment(startDate).format("yyyy-MM-DD"),
      endDate: moment(endDate).format("yyyy-MM-DD"),
      residentName: residentName,
      residentId: residentId,
    }
  );

  const {
    data: repeatfallIncidentsData,
    isFetching: isFetchingRepeatfallIncidents,
  } = getOverviewRepeatfallIncidents;

  const { data: repeatFallDetailsData, isFetching: isLoadingDetails } =
    getRepeatFallDetails;

  useEffect(() => {
    if (repeatfallIncidentsData !== undefined) {
      const tempData = repeatfallIncidentsData?.data.data;
      const transformedTableData = doTransformData(
        tempData,
        "dataInfo",
        "residentName",
        "Total Falls"
      );
      const transformedBarData = transformDataForBarChart(
        transformedTableData,
        "Repeat Count"
      );

      setTableData(transformedTableData);
      shareTableData(transformedTableData);
      setBarData(transformedBarData);
    }
  }, [repeatfallIncidentsData]);

  useEffect(() => {
    if (repeatFallDetailsData) {
      const tempDetails = repeatFallDetailsData.data.data.map((item: any) => ({
        ...item,
      }));
      setRepeatFallDetails(tempDetails);
    }
  }, [repeatFallDetailsData]);

  const title = "Repeat Fall Incidents";

  const handleBarClicked = (chart: any) => {
    if (!chart.length) return;
    const label = handlePointClicked(chart, barData?.labels);
    // Match the drill-down by resident Id (compound Name isn't filterable with
    // Middle Name on). Bars aggregate by name, so only trust the Id when exactly
    // one row matches the label; otherwise fall back to the name filter.
    const matchedRows = (tableData ?? []).filter(
      (row: any) => row.residentName === label
    );
    const resolvedId =
      matchedRows.length === 1 ? matchedRows[0].residentId ?? "" : "";
    setShowRepeatModal(true);
    setResidentName(label);
    setResidentId(resolvedId);
  };

  useEffect(() => {
    //console.log('repeat tableData', tableData);
    let cellCountProps = {
      cells: { data: CenteredWholeNumCell, headerCell: HeaderCenteredCell },
    };
    let cellPercentageProps = {
      cells: {
        data: CenteredWholeNumCell,
        append: "%",
        headerCell: HeaderCenteredCell,
      },
    };
    const grid = (
      <Fragment>
        <Grid
          data={tableData || []}
          scrollable="none"
          rows={{ data: TotalRow }}
        >
          <GridColumn field="residentName" title="Resident" />
          <GridColumn
            field="count"
            title="Number"
            {...(cellCountProps as GridColumnProps)}
          />
          <GridColumn
            field="percentage"
            title="%"
            {...(cellPercentageProps as GridColumnProps)}
          />
        </Grid>
      </Fragment>
    );
    setGrid(grid);
  }, [tableData]);

  return (
    <LayerContent>
      {isFetchingRepeatfallIncidents ? (
        <CustomerLoader />
      ) : (
        <DefaultContainer
          title={title}
          grid={grid}
          handleBarClicked={(chart: any) => handleBarClicked(chart)}
          barData={barData}
          barType="horizontal"
        />
      )}
      {showRepeatModal ? (
        <SectionModal
          open={showRepeatModal}
          facilityName={fallFacility?.label}
          startDate={startDate}
          endDate={endDate}
          closeFn={() => setShowRepeatModal(false)}
          resetFn={() => {
            setResidentName("");
            setResidentId("");
            setRepeatFallDetails(undefined);
          }}
          isLoading={isLoadingDetails || isFetchingSelectedIncident}
          tableData={repeatFallDetails}
          title={`${title} - ${residentName}`}
          getUserCallback={(item: any) => setClickedIncident(item)}
          handlePdfExport={() =>
            handlePDFDownload({
              data: repeatFallDetails,
              columnData: incidentLists(),
              fileName: fallFacility?.label,
              startDate,
              endDate,
              subTitle: `${title} - ${residentName}`,
            })
          }
          handleCsvExport={() =>
            handleCSVDownload(
              repeatFallDetails,
              incidentLists(),
              `${fallFacility?.label}-${title} - ${residentName}`
            )
          }
        />
      ) : null}
    </LayerContent>
  );
};

export default RepeatFall;
